module.exports = __webpack_public_path__ + "static/img/geokrishi_marketplace.ff766e09.png";